import callCmAPI from 'services/helpers/call-cm-api'
import { CustomerGroupT, WebApi2Response } from 'types/global'

/**
 * Fetches every customer group, newest first.
 *
 * The CMAPI wraps responses in `{ success, data }` — we return the
 * raw envelope so callers can branch on `success`.
 */
export const getCustomerGroups = (): Promise<
  WebApi2Response<CustomerGroupT[]>
> =>
  callCmAPI('/customer-group', {
    method: 'get',
  }).then(({ data }) => {
    return data
  })
